import { render, staticRenderFns } from "./EditPersonVehicleDialog.vue?vue&type=template&id=6036755b&scoped=true&"
import script from "./EditPersonVehicleDialog.vue?vue&type=script&lang=js&"
export * from "./EditPersonVehicleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036755b",
  null
  
)

export default component.exports